import { render, staticRenderFns } from "./StockingModal.vue?vue&type=template&id=196b1a8b&"
import script from "./StockingModal.vue?vue&type=script&lang=js&"
export * from "./StockingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockingModal.vue"
export default component.exports